import { useEffect, useState } from 'react';
import { useI18n } from '../../i18n/I18nProvider';
import { useTheme } from '../../theme/ThemeProvider';
import { cx } from '../ui/cx';

/**
 * The tenant's identity: their logo for the active scheme, else their name,
 * else the platform wordmark. Same resolution as the app's ScreenScaffold, so
 * no `elenthor` string reaches a branded tenant's patients.
 */
export function BrandMark({ height = 28, className, subtitle }: { height?: number; className?: string; subtitle?: boolean }) {
  const { logoUrl, displayName } = useTheme();
  const { t } = useI18n();
  // A stored logo URL can outlive its object; the name is always renderable.
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [logoUrl]);

  if (logoUrl && !failed) {
    return (
      <span className={cx('inline-flex items-center', className)}>
        <img src={logoUrl} alt={displayName ?? ''} style={{ height, maxWidth: height * 6.5 }} className="w-auto object-contain object-left rtl:object-right" onError={() => setFailed(true)} />
      </span>
    );
  }
  if (displayName) {
    return (
      <span className={cx('block min-w-0', className)}>
        <span className="block font-serif text-title text-ink truncate">{displayName}</span>
        {subtitle ? <span className="block text-caption text-ink-muted">{t('app.title')}</span> : null}
      </span>
    );
  }
  return (
    <span className={cx('block min-w-0', className)}>
      <span className="wordmark text-ink block" style={{ fontSize: height * 0.82, lineHeight: 1 }}>
        elenthor
      </span>
      {subtitle ? <span className="block text-caption text-ink-muted mt-1">{t('app.title')}</span> : null}
    </span>
  );
}
